import React from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Typography } from '@mui/material';
import { DriverMedicalCheckupsHistoryTable } from './DriverMedicalCheckupsHistoryTable';

interface Props {
    open: boolean;
    onClose: () => void;
    driverId: number | null;
    driverFio: string;
}

export const DriverMedicalCheckupsHistoryModal: React.FC<Props> = ({ open, onClose, driverId, driverFio }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg">
            <DialogTitle sx={{ textAlign: 'center' }}>
                <Typography fontWeight='bold'>История медосмотров водителя</Typography>
                <Typography fontWeight='bold'>{driverFio}</Typography>
            </DialogTitle>
            <DialogContent>
                <Box>
                    {driverId && (
                        <DriverMedicalCheckupsHistoryTable driverId={driverId} />
                    )}
                </Box>
            </DialogContent>
        </Dialog>
    );
};


